export const modalContent = {
    info: [
      {
        prodId:"R3556",
        title:'Choose either Apple One or Apple Music Family.',
        text:["We're sorry but these two perks can't be added on the same line.","The good news Apple Music is included with Apple One. Add the Apple One - Family Subscription for $20/mo, and share it with up to five other people, With this, you'll also get Apple TV+, Apple Arcade and 200GB of iCloud+.","You can get Apple One - Family Subscription and share it with up to five other people or stick with Apple One - Individual Subscription."],
        actions:[{
            type:'button',
            label:"Apple One - Family Subscription",
            id:"R3557",
            size:"100",
            primary:true,
            secondary:false,
            width:"100",
        },
        {
            type:'button',
            label:"Apple One - Individual Subscription",
            id:"R3556",
            size:"100",
            primary:false,
            secondary:true,
            width:"100",
        },
        {
            type:'textlink',
            label:"Switch to Apple music family.",
            id:"R3555",
            size:"",
            disabled:false,
            width:"100",
        }]
      },
      {
        prodId:"R3557",
        title:'Choose either Apple One or Apple Music Family.',
        text:["Apple Music is included with your Apple One perk.","You'll get access to Apple Music through your family subscription to Apple One, shareable with up to 5 other people."],
        actions:[{
            type:'button',
            label:"Got it",
            id:"R3557",
            size:"100",
            primary:true,
            width:"100",
        }]
      },
      {
        prodId:"R3555",
        title:'Choose either Apple One or Apple Music Family.',
        text:["We're sorry but these two perks can't be added on the same line.","Apple One Family Subscription includes Apple Music, plus Apple TV+, Apple Arcade and 200 GB of iCloud+. For $20/mo, add Apple One - Family Subscription, and share it with up to 5 other people."],
        actions:[
            {
                type:'button',
                label:"Apple Music Family",
                id:"R3555",
                size:"100",
                primary:true,
                width:"100",
            },
            {
                type:'button',
                label:"Apple One - Family Subscription",
                id:"R3557",
                size:"100",
                primary:false,
                secondary:true,
                width:"100"
           }
        ]
      },
    ]
}